import { createComponent } from '@lit/react';
import React from 'react';
import { SDSChip } from '../sds-chip/sds-chip';
import { SheriffEventName } from './types';

export const SDSChipWrapper = createComponent({
	tagName: 'sds-chip',
	elementClass: SDSChip,
	react: React,
	events: {
		onChange: 'change' as SheriffEventName,
		onRemove: 'sds-remove' as SheriffEventName,
	},
});
